export const GOLD = "#F5C451";
export const TAG = { fontFamily: "'Permanent Marker', cursive" };

export const STAGES = [
  { key: "scan", label: "SCAN", sub: "Pump.fun + X, every second", ms: 3600 },
  { key: "surface", label: "SURFACE", sub: "The Hive + Grok pull it forward", ms: 3800 },
  { key: "verify", label: "VERIFY", sub: "Rug checks, dev, holders, liquidity", ms: 4200 },
  { key: "buy", label: "BUY", sub: "Sized to the pool, on-chain", ms: 2600 },
  { key: "monitor", label: "MONITOR", sub: "Every tick, every wallet", ms: 5200 },
  { key: "sell", label: "SELL", sub: "Out with profit — then repeat", ms: 3400 },
];

// Illustrative example tokens — not real trades
export const TOKENS = [
  { sym: "TURBOFROG", mcap: 48, buyers: 312, kol: "@degen_oracle", grok: 82, gain: 112, liq: 61 },
  { sym: "CHADCAT", mcap: 35, buyers: 241, kol: "@memewhale", grok: 77, gain: 64, liq: 44 },
  { sym: "MOONPIG", mcap: 71, buyers: 498, kol: "@solsniper", grok: 88, gain: 38, liq: 92 },
  { sym: "BONKERS", mcap: 29, buyers: 205, kol: "@cryptocall", grok: 74, gain: 85, liq: 39 },
  { sym: "GLIZZY", mcap: 56, buyers: 377, kol: "@alphahunter", grok: 80, gain: 47, liq: 70 },
];

export const CHECKS = ["Mint + freeze authority revoked", "Dev wallet clean, no bundle", "Top 10 holders < 30%", "Pool liquidity > $25k", "Sell route verified", "Not a copycat ticker"];

const SYL = ["PEPE", "DOGE", "CAT", "FROG", "MOON", "BONK", "CHAD", "WIF", "PIG", "APE", "GOAT", "KING", "TURBO", "BABY", "SAIL", "ZAP"];
const PHR = ["just aped", "this is the one", "dev is based", "chart looks insane", "CTO incoming", "sending it", "early on this", "volume waking up"];
const pick = (a) => a[Math.floor(Math.random() * a.length)];

export const fakeLaunch = (i) => ({ id: `l${i}`, sym: pick(SYL) + pick(SYL), age: Math.ceil(Math.random() * 59), mcap: (4 + Math.random() * 40).toFixed(1) });
export const fakePost = (i) => ({ id: `p${i}`, who: "@" + pick(SYL).toLowerCase() + pick(["calls", "alpha", "x", "sol", "degen"]), text: `$${pick(SYL)}${pick(SYL)} ${pick(PHR)}` });
